'use strict';

module.exports = function (o) {
  return o != undefined && typeof o.then === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/promise/thenable.js
// module id = 38
// module chunks = 7